import PropTypes from 'prop-types';

// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as c from 'apps/account/appConstants';

const Address = PropTypes.shape({
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  company: PropTypes.string,
  address1: PropTypes.string.isRequired,
  address2: PropTypes.string,
  city: PropTypes.string.isRequired,
  state: PropTypes.string,
  zipcode: PropTypes.string,
  phone: PropTypes.string,
  default_billing: PropTypes.bool,
  default_shipping: PropTypes.bool,
});

const AddressType = PropTypes.oneOf([
  c.ADDRESS_TYPE_BILLING,
  c.ADDRESS_TYPE_SHIPPING,
]);

const ClaimItem = PropTypes.shape({
  serial_number: PropTypes.string,
  replacement_method: PropTypes.string,
  return_reason: PropTypes.string,
  name: PropTypes.string,
  image_url: PropTypes.string,
  shipping_label_url: PropTypes.string,
});

const ClaimItems = PropTypes.arrayOf(ClaimItem);

const CommitmentData = PropTypes.shape({
  date_finished: PropTypes.string,
  device_names: PropTypes.array,
});

const Meta = PropTypes.shape({
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  receivedAt: PropTypes.number,
});

const Order = PropTypes.shape({
  canceled_at: PropTypes.string,
  completed_at: PropTypes.string,
  currency: PropTypes.string,
  discounts_total: PropTypes.number,
  estimated_delivery_date: PropTypes.string,
  excise_tax_total: PropTypes.number,
  item_total: PropTypes.number.isRequired,
  is_membership_order: PropTypes.bool.isRequired,
  number: PropTypes.string.isRequired,
  sales_tax_total: PropTypes.number,
  shipment_total: PropTypes.number.isRequired,
  state: PropTypes.string,
  subscription_id: PropTypes.string,
  total: PropTypes.number.isRequired,
  total_quantity: PropTypes.number.isRequired,
  is_warranty_order: PropTypes.bool.isRequired,
});

const OrderWithLineItems = PropTypes.shape({
  line_items: PropTypes.array.isRequired,
});

const PaymentMethod = PropTypes.shape({
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
});

const PaymentMethods = PropTypes.arrayOf(PaymentMethod);

const PaymentSource = PropTypes.shape({
  source_type: PropTypes.string.isRequired,
  card_type: PropTypes.string,
  last_card_number_digits: PropTypes.string,
  expiry_month: PropTypes.string,
  expiry_year: PropTypes.string,
  email: PropTypes.string,
});

const PodQuantitiesMap = PropTypes.objectOf(PropTypes.number);

const Pod = PropTypes.shape({
  id: PropTypes.string,
  sku: PropTypes.string.isRequired,
  image_url: PropTypes.string.isRequired,
  name: PropTypes.string,
  price: PropTypes.number.isRequired,
});

const Pods = PropTypes.arrayOf(Pod);

const Product = PropTypes.shape({
  name: PropTypes.string,
  price: PropTypes.number.isRequired,
});

const Products = PropTypes.arrayOf(Product);

const ProductRegistration = PropTypes.shape({
  id: PropTypes.number,
  user_id: PropTypes.number,
  variant_id: PropTypes.number,
  accessory_serial_number: PropTypes.string,
  validated_by_serial_number: PropTypes.string,
  product_type: PropTypes.string,
  serial_number: PropTypes.string,
  date_of_purchase: PropTypes.string,
  purchased_from: PropTypes.string,
  legacy_id: PropTypes.number,
  created_at: PropTypes.string,
  updated_at: PropTypes.string,
});

const ProductVariant = PropTypes.shape({
  sku: PropTypes.string,
  price: PropTypes.number,
});

const ProductVariants = PropTypes.arrayOf(ProductVariant);

const Quote = PropTypes.shape({
  subtotal: PropTypes.number,
  shipping: PropTypes.number,
  excise_tax: PropTypes.number,
  state_tax: PropTypes.number,
  total: PropTypes.number,
  order: PropTypes.shape({
    line_items: PropTypes.array.isRequired,
  }),
});

const SubscriptionAddOn = PropTypes.shape({
  product: Product.isRequired,
  quantity: PropTypes.number.isRequired,
});

const Subscription = PropTypes.shape({
  add_ons: PropTypes.arrayOf(SubscriptionAddOn).isRequired,
  is_locked: PropTypes.bool.isRequired,
  next_order_date: PropTypes.string.isRequired,
  payment_method: PaymentSource.isRequired,
  quote: Quote.isRequired,
  status: PropTypes.string.isRequired,
  earliest_allowable_next_order_date: PropTypes.string.isRequired,
});

const SubscriptionQuote = PropTypes.shape({
  addOns: PropTypes.arrayOf(
    PropTypes.shape({
      product: PropTypes.shape({
        id: PropTypes.string,
        sku: PropTypes.string.isRequired,
      }),
      quantity: PropTypes.number.isRequired,
    })
  ),
  subtotal: PropTypes.number.isRequired,
  shipping: PropTypes.number.isRequired,
  excise_tax: PropTypes.number.isRequired,
  signature_fee: PropTypes.number.isRequired,
  state_tax: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
});

const User = PropTypes.shape({
  id: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  phone_verified: PropTypes.bool,
});

const VariantOffering = PropTypes.shape({
  id: PropTypes.number.isRequired,
  variantSku: PropTypes.string.isRequired,
  subscriberExclusive: PropTypes.bool.isRequired,
  isSoldOut: PropTypes.bool.isRequired,
  commitmentReward: PropTypes.shape({
    price: PropTypes.string,
    requiredInstallmentCount: PropTypes.number,
  }),
});

const propTypes = {
  ...PropTypes,
  Address,
  AddressType,
  ClaimItem,
  ClaimItems,
  CommitmentData,
  Meta,
  Order,
  OrderWithLineItems,
  PaymentMethod,
  PaymentMethods,
  PaymentSource,
  PodQuantitiesMap,
  Pod,
  Pods,
  Product,
  Products,
  ProductRegistration,
  ProductVariant,
  ProductVariants,
  Quote,
  Subscription,
  SubscriptionQuote,
  User,
  VariantOffering,
};

export default propTypes;
